/* Auto-generated from text-zone-template.ejs */
const template = function anonymous(data, escapeFn, include, rethrow
) {
"use strict";
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div id=\"template-text-zone-<%- data.zoneIndex %>\" data-free-object-id=\"<%- data.freeObjectId %>\" data-type=\"text\"\n     class=\"template-zone text-zone\">\n    <div class=\"field\">\n        <div class=\"control is-fullwidth\">\n            <input autocomplete=\"off\"\n                   id=\"zone-text-<%- data.freeObjectId %>\"\n                   data-free-object-id=\"<%- data.freeObjectId %>\"\n                   data-default=\"<%- data.textDefault %>\"\n                   class=\"input zone-text\"\n                   type=\"text\"\n                   aria-label=\"<%- data.tr('TEXT_INPUT', 'Text Input') %>\"\n                   value=\"<%- data.textDefault %>\"\n            />\n        </div>\n    </div>\n    <div class=\"text-controls columns is-justify-content-space-between\">\n        <% if (data.showFontSize) { %>\n        <div class=\"column text-size\">\n            <div class=\"field\">\n                <div class=\"control has-icons-left\">\n                    <div class=\"select is-fullwidth\">\n                        <select aria-label=\"Font Size\" id=\"zone-font-size-<%- data.freeObjectId %>\" data-free-object-id=\"<%- data.freeObjectId %>\"\n                                class=\"zone-font-size\">\n                            <%\n                            let maxSize = data.textSize > 500 ? data.textSize : 500;\n                            let shownTextSize = false;\n                            for (let i = 8, nextSize = 8; i <= maxSize; i = nextSize) {\n                                if (nextSize > 140) {\n                                    nextSize += 36;\n                                    if (nextSize > maxSize && nextSize < maxSize + 30) {\n                                        nextSize = maxSize;\n                                    }\n                                } else if (i >= 72) {\n                                    nextSize += 12;\n                                } else if (i > 11) {\n                                    nextSize += 2\n                                } else {\n                                    nextSize += 1;\n                                }\n                                if (i === data.textSize) {\n                                    shownTextSize = true;\n                            %>\n                            <option value=\"<%- i %>\" selected><%- i %></option>\n                            <%\n                                } else {\n                                    if (i > data.textSize && !shownTextSize) {\n                            %>\n                            <option value=\"<%- data.textSize %>\" selected><%- data.textSize %></option>\n                            <%\n                                        shownTextSize = true;\n                                    }\n                            %>\n                            <option value=\"<%- i %>\"><%- i %></option>\n                            <%\n                                }\n                            } %>\n                        </select>\n                        <span class=\"icon is-small is-left text-height-icon\"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <% } %>\n        <% if (data.showTextControls) { %>\n        <%      if (data.showFontColor) { %>\n        <div class=\"column text-color\">\n            <div class=\"field\">\n                <div class=\"control\">\n                    <div class=\"control has-icons-left\">\n                        <input aria-label=\"Text Color\" autocomplete=\"off\" id=\"zone-text-color-<%- data.freeObjectId %>\"\n                               data-free-object-id=\"<%- data.freeObjectId %>\" class=\"input zone-text-color\" type=\"color\"\n                               value=\"<%- data.textColor %>\"/>\n                        <span class=\"icon is-small is-left palette-icon\"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <%      } %>\n        <%      if (data.showTextAlign) { %>\n        <div class=\"is-flex align-controls\">\n            <div class=\"field px-1\">\n                <label for=\"zone-text-align-left-<%- data.freeObjectId %>\" class=\"label\">\n                    <input id=\"zone-text-align-left-<%- data.freeObjectId %>\" name=\"zone-text-align-<%- data.freeObjectId %>\"\n                           data-free-object-id=\"<%- data.freeObjectId %>\" value=\"left\"\n                           class=\"zone-text-align toggle\" type=\"radio\"<% if (data.textAlign=='left') { %>checked<% } %>\n                    />\n                    <span class=\"left-align-icon icon\"></span>\n                </label>\n            </div>\n\n            <div class=\"field px-1\">\n                <label for=\"zone-text-align-center-<%- data.freeObjectId %>\" class=\"label\">\n                    <input id=\"zone-text-align-center-<%- data.freeObjectId %>\"\n                           name=\"zone-text-align-<%- data.freeObjectId %>\"\n                           data-free-object-id=\"<%- data.freeObjectId %>\" value=\"center\"\n                           class=\"zone-text-align toggle\" type=\"radio\"<% if (data.textAlign=='center') { %>checked<% } %>\n                    />\n                    <span class=\"center-align-icon icon\"></span>\n                </label>\n            </div>\n            <div class=\"field px-1\">\n                <label for=\"zone-text-align-right-<%- data.freeObjectId %>\" class=\"label\">\n                    <input id=\"zone-text-align-right-<%- data.freeObjectId %>\" name=\"zone-text-align-<%- data.freeObjectId %>\"\n                           data-free-object-id=\"<%- data.freeObjectId %>\" value=\"right\"\n                           class=\"zone-text-align toggle\" type=\"radio\"<% if (data.textAlign=='right') { %>checked<% } %>\n                    />\n                    <span class=\"right-align-icon icon\"></span>\n                </label>\n            </div>\n        </div>\n        <%      } %>\n        <%      if (data.showTextStyle) { %>\n        <div id=\"bold-italic-underline\" class=\"column is-flex is-justify-content-flex-end\">\n            <%      if (data.canBold) { %>\n            <div class=\"toggle-check-column font-style\">\n                <div class=\"field\">\n                    <label for=\"zone-font-bold-<%- data.freeObjectId %>\" class=\"label\">\n                        <input id=\"zone-font-bold-<%- data.freeObjectId %>\" data-can-bold-italic=\"<%- data.canBoldItalic %>\"\n                               data-free-object-id=\"<%- data.freeObjectId %>\" class=\"zone-font-bold toggle\"\n                               type=\"checkbox\" <% if (data.fontBold) { %> checked<% } %>/>\n                        <i class=\"fa fa-fw fa-bold\"></i>\n                    </label>\n                </div>\n            </div>\n            <%      } %>\n            <%      if (data.canItalic) { %>\n            <div class=\"toggle-check-column font-style\">\n                <div class=\"field\">\n                    <label for=\"zone-font-italic-<%- data.freeObjectId %>\" class=\"label\">\n                        <input id=\"zone-font-italic-<%- data.freeObjectId %>\" data-can-bold-italic=\"<%- data.canBoldItalic %>\"\n                               data-free-object-id=\"<%- data.freeObjectId %>\" class=\"zone-font-italic toggle\"\n                               type=\"checkbox\"\n                        <% if (data.fontItalic) { %>checked<% } %>\n                        />\n                        <i class=\"fa fa-fw fa-italic\"></i>\n                    </label>\n                </div>\n            </div>\n            <%      } %>\n            <div class=\"toggle-check-column font-style\">\n                <div class=\"field\">\n                    <label for=\"zone-font-underline-<%- data.freeObjectId %>\" class=\"label\">\n                        <input id=\"zone-font-underline-<%- data.freeObjectId %>\"\n                               data-free-object-id=\"<%- data.freeObjectId %>\"\n                               class=\"zone-font-underline toggle\" type=\"checkbox\"\n                        <% if (data.fontUnderline) { %>checked<% } %>\n                        />\n                        <i class=\"fa fa-fw fa-underline\"></i>\n                    </label>\n                </div>\n            </div>\n        </div>\n        <%      } %>\n        <% } %>\n    </div>\n</div>\n\n"
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
    ; __append("<div id=\"template-text-zone-")
    ; __append( data.zoneIndex )
    ; __append("\" data-free-object-id=\"")
    ; __append( data.freeObjectId )
    ; __append("\" data-type=\"text\"\n     class=\"template-zone text-zone\">\n    <div class=\"field\">\n        <div class=\"control is-fullwidth\">\n            <input autocomplete=\"off\"\n                   id=\"zone-text-")
    ; __line = 6
    ; __append( data.freeObjectId )
    ; __append("\"\n                   data-free-object-id=\"")
    ; __line = 7
    ; __append( data.freeObjectId )
    ; __append("\"\n                   data-default=\"")
    ; __line = 8
    ; __append( data.textDefault )
    ; __append("\"\n                   class=\"input zone-text\"\n                   type=\"text\"\n                   aria-label=\"")
    ; __line = 11
    ; __append( data.tr('TEXT_INPUT', 'Text Input') )
    ; __append("\"\n                   value=\"")
    ; __line = 12
    ; __append( data.textDefault )
    ; __append("\"\n            />\n        </div>\n    </div>\n    <div class=\"text-controls columns is-justify-content-space-between\">\n        ")
    ; __line = 17
    ;  if (data.showFontSize) { 
    ; __append("\n        <div class=\"column text-size\">\n            <div class=\"field\">\n                <div class=\"control has-icons-left\">\n                    <div class=\"select is-fullwidth\">\n                        <select aria-label=\"Font Size\" id=\"zone-font-size-")
    ; __line = 22
    ; __append( data.freeObjectId )
    ; __append("\" data-free-object-id=\"")
    ; __append( data.freeObjectId )
    ; __append("\"\n                                class=\"zone-font-size\">\n                            ")
    ; __line = 24
    ; 
                            let maxSize = data.textSize > 500 ? data.textSize : 500;
                            let shownTextSize = false;
                            for (let i = 8, nextSize = 8; i <= maxSize; i = nextSize) {
                                if (nextSize > 140) {
                                    nextSize += 36;
                                    if (nextSize > maxSize && nextSize < maxSize + 30) {
                                        nextSize = maxSize;
                                    }
                                } else if (i >= 72) {
                                    nextSize += 12;
                                } else if (i > 11) {
                                    nextSize += 2
                                } else {
                                    nextSize += 1;
                                }
                                if (i === data.textSize) {
                                    shownTextSize = true;
                            
    ; __line = 42
    ; __append("\n                            <option value=\"")
    ; __line = 43
    ; __append( i )
    ; __append("\" selected>")
    ; __append( i )
    ; __append("</option>\n                            ")
    ; __line = 44
    ; 
                                } else {
                                    if (i > data.textSize && !shownTextSize) {
                            
    ; __line = 47
    ; __append("\n                            <option value=\"")
    ; __line = 48
    ; __append( data.textSize )
    ; __append("\" selected>")
    ; __append( data.textSize )
    ; __append("</option>\n                            ")
    ; __line = 49
    ; 
                                        shownTextSize = true;
                                    }
                            
    ; __line = 52
    ; __append("\n                            <option value=\"")
    ; __line = 53
    ; __append( i )
    ; __append("\">")
    ; __append( i )
    ; __append("</option>\n                            ")
    ; __line = 54
    ; 
                                }
                            } 
    ; __line = 56
    ; __append("\n                        </select>\n                        <span class=\"icon is-small is-left text-height-icon\"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        ")
    ; __line = 63
    ;  } 
    ; __append("\n        ")
    ; __line = 64
    ;  if (data.showTextControls) { 
    ; __append("\n        ")
    ; __line = 65
    ;       if (data.showFontColor) { 
    ; __append("\n        <div class=\"column text-color\">\n            <div class=\"field\">\n                <div class=\"control\">\n                    <div class=\"control has-icons-left\">\n                        <input aria-label=\"Text Color\" autocomplete=\"off\" id=\"zone-text-color-")
    ; __line = 70
    ; __append( data.freeObjectId )
    ; __append("\"\n                               data-free-object-id=\"")
    ; __line = 71
    ; __append( data.freeObjectId )
    ; __append("\" class=\"input zone-text-color\" type=\"color\"\n                               value=\"")
    ; __line = 72
    ; __append( data.textColor )
    ; __append("\"/>\n                        <span class=\"icon is-small is-left palette-icon\"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        ")
    ; __line = 78
    ;       } 
    ; __append("\n        ")
    ; __line = 79
    ;       if (data.showTextAlign) { 
    ; __append("\n        <div class=\"is-flex align-controls\">\n            <div class=\"field px-1\">\n                <label for=\"zone-text-align-left-")
    ; __line = 82
    ; __append( data.freeObjectId )
    ; __append("\" class=\"label\">\n                    <input id=\"zone-text-align-left-")
    ; __line = 83
    ; __append( data.freeObjectId )
    ; __append("\" name=\"zone-text-align-")
    ; __append( data.freeObjectId )
    ; __append("\"\n                           data-free-object-id=\"")
    ; __line = 84
    ; __append( data.freeObjectId )
    ; __append("\" value=\"left\"\n                           class=\"zone-text-align toggle\" type=\"radio\"")
    ; __line = 85
    ;  if (data.textAlign=='left') { 
    ; __append("checked")
    ;  } 
    ; __append("\n                    />\n                    <span class=\"left-align-icon icon\"></span>\n                </label>\n            </div>\n\n            <div class=\"field px-1\">\n                <label for=\"zone-text-align-center-")
    ; __line = 92
    ; __append( data.freeObjectId )
    ; __append("\" class=\"label\">\n                    <input id=\"zone-text-align-center-")
    ; __line = 93
    ; __append( data.freeObjectId )
    ; __append("\"\n                           name=\"zone-text-align-")
    ; __line = 94
    ; __append( data.freeObjectId )
    ; __append("\"\n                           data-free-object-id=\"")
    ; __line = 95
    ; __append( data.freeObjectId )
    ; __append("\" value=\"center\"\n                           class=\"zone-text-align toggle\" type=\"radio\"")
    ; __line = 96
    ;  if (data.textAlign=='center') { 
    ; __append("checked")
    ;  } 
    ; __append("\n                    />\n                    <span class=\"center-align-icon icon\"></span>\n                </label>\n            </div>\n            <div class=\"field px-1\">\n                <label for=\"zone-text-align-right-")
    ; __line = 102
    ; __append( data.freeObjectId )
    ; __append("\" class=\"label\">\n                    <input id=\"zone-text-align-right-")
    ; __line = 103
    ; __append( data.freeObjectId )
    ; __append("\" name=\"zone-text-align-")
    ; __append( data.freeObjectId )
    ; __append("\"\n                           data-free-object-id=\"")
    ; __line = 104
    ; __append( data.freeObjectId )
    ; __append("\" value=\"right\"\n                           class=\"zone-text-align toggle\" type=\"radio\"")
    ; __line = 105
    ;  if (data.textAlign=='right') { 
    ; __append("checked")
    ;  } 
    ; __append("\n                    />\n                    <span class=\"right-align-icon icon\"></span>\n                </label>\n            </div>\n        </div>\n        ")
    ; __line = 111
    ;       } 
    ; __append("\n        ")
    ; __line = 112
    ;       if (data.showTextStyle) { 
    ; __append("\n        <div id=\"bold-italic-underline\" class=\"column is-flex is-justify-content-flex-end\">\n            ")
    ; __line = 114
    ;       if (data.canBold) { 
    ; __append("\n            <div class=\"toggle-check-column font-style\">\n                <div class=\"field\">\n                    <label for=\"zone-font-bold-")
    ; __line = 117
    ; __append( data.freeObjectId )
    ; __append("\" class=\"label\">\n                        <input id=\"zone-font-bold-")
    ; __line = 118
    ; __append( data.freeObjectId )
    ; __append("\" data-can-bold-italic=\"")
    ; __append( data.canBoldItalic )
    ; __append("\"\n                               data-free-object-id=\"")
    ; __line = 119
    ; __append( data.freeObjectId )
    ; __append("\" class=\"zone-font-bold toggle\"\n                               type=\"checkbox\" ")
    ; __line = 120
    ;  if (data.fontBold) { 
    ; __append(" checked")
    ;  } 
    ; __append("/>\n                        <i class=\"fa fa-fw fa-bold\"></i>\n                    </label>\n                </div>\n            </div>\n            ")
    ; __line = 125
    ;       } 
    ; __append("\n            ")
    ; __line = 126
    ;       if (data.canItalic) { 
    ; __append("\n            <div class=\"toggle-check-column font-style\">\n                <div class=\"field\">\n                    <label for=\"zone-font-italic-")
    ; __line = 129
    ; __append( data.freeObjectId )
    ; __append("\" class=\"label\">\n                        <input id=\"zone-font-italic-")
    ; __line = 130
    ; __append( data.freeObjectId )
    ; __append("\" data-can-bold-italic=\"")
    ; __append( data.canBoldItalic )
    ; __append("\"\n                               data-free-object-id=\"")
    ; __line = 131
    ; __append( data.freeObjectId )
    ; __append("\" class=\"zone-font-italic toggle\"\n                               type=\"checkbox\"\n                        ")
    ; __line = 133
    ;  if (data.fontItalic) { 
    ; __append("checked")
    ;  } 
    ; __append("\n                        />\n                        <i class=\"fa fa-fw fa-italic\"></i>\n                    </label>\n                </div>\n            </div>\n            ")
    ; __line = 139
    ;       } 
    ; __append("\n            <div class=\"toggle-check-column font-style\">\n                <div class=\"field\">\n                    <label for=\"zone-font-underline-")
    ; __line = 142
    ; __append( data.freeObjectId )
    ; __append("\" class=\"label\">\n                        <input id=\"zone-font-underline-")
    ; __line = 143
    ; __append( data.freeObjectId )
    ; __append("\"\n                               data-free-object-id=\"")
    ; __line = 144
    ; __append( data.freeObjectId )
    ; __append("\"\n                               class=\"zone-font-underline toggle\" type=\"checkbox\"\n                        ")
    ; __line = 146
    ;  if (data.fontUnderline) { 
    ; __append("checked")
    ;  } 
    ; __append("\n                        />\n                        <i class=\"fa fa-fw fa-underline\"></i>\n                    </label>\n                </div>\n            </div>\n        </div>\n        ")
    ; __line = 153
    ;       } 
    ; __append("\n        ")
    ; __line = 154
    ;  } 
    ; __append("\n    </div>\n</div>\n\n")
    ; __line = 158
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

};
export default template;
